var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.44531V2.07031C11.2812 2.53906 13 4.53906 13 6.94531V7.53906C13 9.00781 13.5312 10.4453 14.5 11.5391L14.7188 11.7891C15 12.1016 15.0625 12.5078 14.9062 12.8828C14.75 13.2266 14.375 13.4453 14 13.4453H2C1.59375 13.4453 1.21875 13.2266 1.0625 12.8828C0.90625 12.5078 0.96875 12.1016 1.25 11.7891L1.46875 11.5391C2.4375 10.4453 3 9.00781 3 7.53906V6.94531C3 4.53906 4.6875 2.53906 7 2.07031V1.44531C7 0.914062 7.4375 0.445312 8 0.445312C8.53125 0.445312 9 0.914062 9 1.44531ZM8 16.4453C7.46875 16.4453 6.9375 16.2578 6.5625 15.8828C6.1875 15.5078 6 14.9766 6 14.4453H10C10 14.9766 9.78125 15.5078 9.40625 15.8828C9.03125 16.2578 8.5 16.4453 8 16.4453Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon_bell.de7587721a0b0d40782876dd549b0a78.svg";
export { ForwardRef as ReactComponent };